import { Spinner } from '@optools/components/loading/spinner';
import { TeamSpot } from '@optools/components/team-spot';
import { WITH_MiLB_SPORT_IDS } from '@optools/services/statsapi/teams';
import { useTeamsQuery } from '@optools/store/statsApiSlice';

export interface EsniTeamSpotProps {
  feedSubType: string | undefined | null;
}

export function EsniTeamSpot({ feedSubType }: EsniTeamSpotProps) {
  // Include MiLB Teams
  const { data: teams, isLoading: teamsLoading } = useTeamsQuery(WITH_MiLB_SPORT_IDS);
  if (teamsLoading) {
    return <Spinner />;
  }

  const team = teams?.find((team) => team.id.toString() === feedSubType);
  return team ? (
    <TeamSpot size={30} team={team} />
  ) : (
    <span>{feedSubType ? feedSubType : 'None'}</span>
  );
}
